/** Colores para los gráficos. */
export const COLORES_GRAFICOS = [
  '#29acbb',
  '#da7a43',
  '#1ea2aa',
  '#0871b3',
  '#018b91',
]
